

import common from '@/tools/common'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
methods: {
filter: function () {
this.$forceUpdate()
}
},
computed: {
NavData: function () {
if (this.$route.query.UserType) {
window.localStorage.setItem('UserType', this.$route.query.UserType)
}
let userType = window.localStorage.getItem('UserType')
let power = common.getPower()
let queryData = []
if (power) {
queryData = power.split('_')
}
let navData = this.GridData
.filter(item => (!item.UserType) || item.UserType.includes(userType))
.filter(item => (!item.QueryData) || item.QueryData.some(r => queryData.indexOf(r) >= 0))

if (this.p_name) {
navData = navData.filter(item => item.text.includes(this.p_name))
}
return navData
}
},
props: {
GridData: Array,
OneHeight: Number,
Searchable: Boolean
},
data () {
return {
p_name: ''
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/NavTradeGrid.vue